module.exports = require("./fr-CM");